/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package core.domain

class NotFoundException : ApiException(message = "Not found.")